module.exports = __webpack_public_path__ + "img/mobile/PromoBetBar/panel_background@1x.png?1.0.17";